import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Modal, Button } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { formatDateToIST, IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import Select from "react-select";
import Loader from "../../common/Loader/Loader";
import { Permission } from "../../../utils/permission";
import StaffForm from "./StaffForm";
// import { Modal, Button } from "react-bootstrap";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [searchEmail, setsearchEmail] = useState("");
  const [searchNumber, setsearchNumber] = useState("");
  const [EmployeeId, setEmployeeId] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [searchDate, setSearchDate] = useState("");
  const [searchDateTo, setSearchDateTo] = useState("");

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddresses, setSelectedAddresses] = useState([]);
  const [loading, setLoading] = useState(false);

  // const sortedData = data?.data?.data || [];

  const getDataAll = async () => {
    setLoading(true);

    const response = await getData(
      `/admin/employee-management/supervisor?page=${onPageChange ||
        1}&per_page=${perPage || 5}&term=${search ||
        ""}&employee_id=${EmployeeId || ""}&searchEmail=${searchEmail ||
        ""}&searchNumber=${searchNumber || ""}&from=${searchDate ||
        ""}&to=${searchDateTo || ""}`,
    );

    await setData(response);
    if (response?.success) {
      setLoading(false);
    }
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  // useEffect(() => {
  //   getDataAll();
  // }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(
      `/admin/employee-management/supervisor/${id}`,
    );
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/admin/employee-management/supervisor/${recordToDeleteId}`,
      );
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  const handleViewAddress = (addresses) => {
    setSelectedAddresses(addresses);
    setShowAddressModal(true);
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const BulkUpload = async (e) => {
    try {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const response = await postData(
        "/admin/employee-management/supervisor/bulk",
        formData,
        {},
      );
      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        setShowoff(response?.data);
      }, 1000);
      getDataAll();
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const Sample = async (e) => {
    try {
      await getDownloadDataExcel(
        "/admin/employee-management/supervisor/sample",
        {},
        "Category",
      );
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        await getDownloadDataExcel(
          `/admin/employee-management/supervisor/download?page=${onPageChange ||
            1}&per_page=${perPage || 5}&employee_id=${EmployeeId ||
            ""}&term=${search || ""}&searchEmail=${searchEmail ||
            ""}&searchNumber=${searchNumber || ""}&from=${searchDate ||
            ""}&to=${searchDateTo || ""}`,
          null,
          "Supervisor List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Supervisor"}
          link={"/admin/employee-management/supervisor"}
        />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  {/* container */}
                  <div className="row">
                    <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                      <div className="add me-3">
                        {isAllow.includes(Permission.Supervisor.Add.id) ? (
                          <Link type="button" className="btn btn-add pe-3">
                            <div onClick={() => handleShow()}>
                              <img
                                src={plus}
                                className="plus me-2 ms-0"
                                alt=""
                              />
                              Add Supervisor
                            </div>
                          </Link>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className=" col-12">
                        <div className="d-flex align-items-center mb-3">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">{`Showing ${Math.min(
                              (currentPage - 1) * perPage + 1,
                            )} to ${Math.min(
                              currentPage * perPage,
                              data?.data?.total,
                            )} of ${data?.data?.total} entries`}</p>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12">
                        <div className="row align-items-end mb-3">
                          <div className="col-12 mb-2">
                            <div className="row">
                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                                <div className="num">
                                  <label className="form-label">Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value={search}
                                    placeholder="Search Customer"
                                    onChange={(e) => {
                                      setSearch(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                                <div className="num">
                                  <label className="form-label">Email</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value={searchEmail}
                                    placeholder="Search Email"
                                    onChange={(e) => {
                                      setsearchEmail(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                                <div className="num">
                                  <label className="form-label">
                                    Contact Number
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value={searchNumber}
                                    placeholder="Contact Number"
                                    onChange={(e) => {
                                      setsearchNumber(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                                <div className="num">
                                  <label className="form-label">
                                    Employee Id
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={EmployeeId}
                                    placeholder="Employee Id"
                                    onChange={(e) => {
                                      setEmployeeId(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                                <div className="num me-2">
                                  <label className="form-label">
                                    Start Date
                                  </label>
                                  <input
                                    type="date"
                                    min="0001-01-01"
                                    max="9999-12-31"
                                    className="form-control"
                                    placeholder="from"
                                    value={searchDate}
                                    onChange={(e) => {
                                      setSearchDate(e.target.value);
                                      setSearchDateTo("");
                                      setonPageChange(1);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                                <div className="num me-2">
                                  <label className="form-label">End Date</label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    min={searchDate ? searchDate : "0001-01-01"}
                                    max="9999-12-31"
                                    placeholder="to"
                                    value={searchDateTo}
                                    onChange={(e) => {
                                      setSearchDateTo(e.target.value);
                                      setonPageChange(1);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                                <div className="Search me-2">
                                  <Button
                                    type="button"
                                    onClick={() => {
                                      setonPageChange(1);
                                      getDataAll();
                                    }}
                                    className="btn btn-search"
                                  >
                                    <img
                                      src={search1}
                                      className="search"
                                      alt=""
                                    />
                                  </Button>
                                </div>
                                <div className="Search-1">
                                  <div>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setSearch("");
                                        setsearchEmail("");
                                        setsearchNumber("");
                                        setEmployeeId("");
                                        setSearchDate("");
                                        setSearchDateTo("");
                                        setReset(!reset);
                                      }}
                                      className="btn btn-reset"
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                                <div>
                                  <button
                                    className="btn btn-success "
                                    type="button"
                                    onClick={HandleDownload}
                                  >
                                    Download Excel
                                    <FontAwesomeIcon
                                      icon="fa-solid fa-file-lines"
                                      className="ms-2"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            <th className="sr" style={{ width: "10%" }}>
                              Sr. No.
                            </th>
                            <th className="tax-name" style={{ width: "10%" }}>
                              Created On{" "}
                            </th>
                            <th className="tax-name" style={{ width: "10%" }}>
                              Employee Id{" "}
                            </th>

                            <th className="tax-name" style={{ width: "10%" }}>
                              Name{" "}
                            </th>

                            <th className="tax-name" style={{ width: "10%" }}>
                              Email{" "}
                            </th>

                            <th className="tax-name" style={{ width: "10%" }}>
                              Contact No{" "}
                            </th>
                            <th className="tax-name" style={{ width: "10%" }}>
                              Address{" "}
                            </th>
                            <th className="tax-name" style={{ width: "10%" }}>
                              Added By{" "}
                            </th>

                            {/* <th className="tax-name" style={{ width: "10%" }}>
                              Status
                            </th> */}

                            <th className="active" style={{ width: "10%" }}>
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan={88}>
                                <Loader type="dots" />
                              </td>
                            </tr>
                          ) : (
                            data?.data?.data?.map((d, index) => {
                              const paginatedIndex =
                                (onPageChange - 1) * perPage + index + 1;
                              return (
                                <tr className="" key={index}>
                                  <td>{paginatedIndex}.</td>
                                  <td>
                                    {formatDateToIST(d?.createdAt, true) || "-"}
                                  </td>
                                  <td>{d?.employee_id || "-"}</td>

                                  <td>{d?.name || "-"}</td>
                                  <td>{d?.email || "-"}</td>
                                  <td>{d?.contact_no || "-"}</td>

                                  <td>
                                    {d?.User_Addresses?.length > 0 ? (
                                      <Button
                                        variant="info"
                                        size="sm"
                                        onClick={() =>
                                          handleViewAddress(d?.User_Addresses)
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEye} />
                                      </Button>
                                    ) : (
                                      <span>No Address</span>
                                    )}
                                  </td>
                                  <td>{d?.CreatedBy?.name || "-"}</td>

                                  {/* <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        checked={d.status}
                                        disabled={
                                          !isAllow?.includes(
                                            Permission.Supervisor.Edit.id,
                                          )
                                        }
                                        onChange={() => {
                                          ChangeStatus(d.id);
                                        }}
                                        id={`flexSwitchCheckDefault${d?.id}`}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                      >
                                        {d.status ? "Active" : "Inactive"}
                                      </label>
                                    </div>
                                  </td> */}

                                  <td>
                                    <div className="d-flex">
                                      {isAllow.includes(
                                        Permission.Supervisor.Edit.id,
                                      ) && (
                                        <EditButton
                                          handleShow1={setShowEdit}
                                          id={d.id}
                                        />
                                      )}
                                      {/* {isAllow.includes(
                                            Permission.Supervisor.List.id,
                                          ) && (
                                            <Link to={`/supervisors/view/${d?.id}`}>
                                              <Button
                                                type="button"
                                                className="btn btn-primary me-1"
                                              >
                                                <FontAwesomeIcon icon="fa-solid fa-eye" />
                                              </Button>
                                            </Link>
                                          )} */}

                                      {/* {isAllow.includes(
                                        Permission.Supervisor.Delete.id,
                                      ) ? (
                                        <DeletButton
                                          showDeleteRecord={showDeleteRecord}
                                          id={d?.id}
                                          name={d?.name}
                                        />
                                      ) : (
                                        <></>
                                      )} */}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <StaffForm
          editId={0}
          show={show}
          handleClose={() => setShowAdd(false)}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <StaffForm
          editId={show1}
          show={!!show1}
          handleClose={() => setShowEdit(0)}
        />
      ) : (
        ""
      )}

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />

      <Modal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
        size="lg"
        centered
        className="userdeatailspp"
      >
        <Modal.Header closeButton>
          <Modal.Title>User Address Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAddresses.length > 0 ? (
            selectedAddresses.map((address, index) => (
              <div key={index} className="mb-3 border p-2 rounded">
                <h5 className="mb-3">Address {index + 1}</h5>
                <div className="row">
                  <div className="col-lg-6">
                    <p>
                      <strong>Building:</strong> {address.building}
                    </p>
                  </div>
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Floor:</strong> {address.floor}
                    </p>
                  </div> */}
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Apartment:</strong> {address.apartment}
                    </p>
                  </div> */}
                  <div className="col-lg-6">
                    <p>
                      <strong>Street:</strong> {address.street}
                    </p>
                  </div>
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Direction:</strong> {address.direction}
                    </p>
                  </div> */}
                  <div className="col-lg-6">
                    <p>
                      <strong>Contact No:</strong> {address.contact_no}
                    </p>
                  </div>
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Latitude:</strong> {address.lat}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>Longitude:</strong> {address.long}
                    </p>
                  </div> */}
                  <div className="col-lg-6">
                    <p>
                      <strong>Country:</strong>{" "}
                      {address.Users_Address_Detail?.Country?.name}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>State:</strong>{" "}
                      {address.Users_Address_Detail?.State?.name}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>City:</strong>{" "}
                      {address.Users_Address_Detail?.City?.name}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>Pincode:</strong>{" "}
                      {address.Users_Address_Detail?.Pincode?.name}
                    </p>
                  </div>
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Area:</strong>{" "}
                      {address.Users_Address_Detail?.Area?.name}
                    </p>
                  </div> */}
                </div>
              </div>
            ))
          ) : (
            <p>No address details available.</p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tables;
